import { type UpdateHookResponse, mutationUpdate } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useAccountStatusCache } from './cache'
import {
  type AccountStatusData,
  type AccountStatusUpdateInput,
  type AccountStatusUpdateSuccess,
  Logger,
  toResponseError,
} from '@terros/common'

const logger = new Logger('useUpdateAccountStatus')
// logger.level = 'verbose'

export function useUpdateAccountStatus(): UpdateHookResponse<AccountStatusData> {
  const cache = useAccountStatusCache()
  const mutation = useTantalimMutation<AccountStatusUpdateInput, AccountStatusUpdateSuccess>({
    url: '/account/status/update',
  })

  async function update(unsaved: AccountStatusData): Promise<AccountStatusData> {
    try {
      const { status } = await mutation.mutateAsync({ status: unsaved })
      logger.verbose('update succeeded', status)
      cache.replaceItem(status)

      return status
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
